<a fxLayout="row" [routerLink]=itemRouterLink (mouseenter) ="mouseEnter()" (mouseleave)="mouseLeave()" [style]=itemStyle>
    <mat-icon  class="menu-item">{{ itemIcon }}</mat-icon>
    <mat-label class="menu-item">{{ itemTitle }}</mat-label>
    
